// Admin → Management → Demos (design/2026-10-22-chief-of-staff-and-demos.md
// T19): a demo story's card, the demo-customer switch, the last Reset and
// its warning, the steps, and what Reset does. It outlines the controls and
// never clicks the switch, Reset, Reset now or a step: each one changes or
// deletes something.

import type { Walkthrough } from './types'

export const demosReset: Walkthrough = {
  slug: 'demos-reset',
  title: 'Demos and Reset',
  summary:
    'Opens Admin → Demos and shows a demo story: its demo customer switch, when it was last reset, its steps and what Reset deletes and loads again. Nothing is marked, reset or played.',
  added: '2026-10-22',
  steps: [
    {
      page: 'admin-demos',
      feature: 'operations/demos',
      say: 'This is Demos. Each card is a demo story built into Platinum: a fictional customer with its jobs, laid down on demand so a demo always starts from the same place.',
    },
    {
      page: 'admin-demos',
      feature: 'operations/demos',
      control: 'Demo customer',
      say: 'Demo customer marks the story’s customer as one Reset may work on. Until it is on, Reset and the steps refuse that customer, so a mistake can never touch a real one. Switching it asks you to confirm first.',
    },
    {
      page: 'admin-demos',
      feature: 'operations/demos',
      say: 'Under the title: when the story was last reset, by whom and where. If it was reset in the other environment, a warning says so: staging and production share the customer’s files, so reset where you are about to demo.',
    },
    {
      page: 'admin-demos',
      feature: 'operations/demo-steps',
      control: 'Play step',
      say: 'Steps hold some of the story’s data back, such as scanning the connected social accounts. Playing one shows the story’s funnel counting up, then the data appears. The same button is on the demo job’s AutoCoder pipeline page.',
    },
    {
      page: 'admin-demos',
      feature: 'operations/demo-reset',
      control: 'Reset',
      say: 'Reset deletes everything of the story’s customer except the ledgers, then loads the story again. Its box first lists what it will delete, and Reset now stays disabled until you type reset. A walkthrough never resets for you.',
    },
  ],
}
